module.exports = __webpack_public_path__ + "static/media/login_background.9ecbc376.jpg";